<form [formGroup]="selectSpecialityForm">
	<div class="row">
		<div class="col-md-12">
			<mat-form-field class="select-speciality-form form-group">
				<mat-chip-grid #chipList formControlName="speciality">
					<mat-chip-row *ngFor="let speciality of specialities" [removable]="removable" (removed)="remove(speciality)">
						{{ speciality.name }}
						<mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
					</mat-chip-row>
					<input
						matInput
						#specialitiesInput
						placeholder="{{ 'referral.request-referral.select-specialty.select' | translate }}"
						[formControl]="specialityCtrl"
						[matAutocomplete]="auto"
						[matChipInputFor]="chipList"
						[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
						(focus)="onFocus()"
						(click)="onFocus()"
						[matChipInputAddOnBlur]="addOnBlur"
						(matChipInputTokenEnd)="add($event)" />
				</mat-chip-grid>
				<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
					<mat-option *ngFor="let speciality of filteredSpecialities | async" [value]="speciality">
						{{ speciality.name }}
					</mat-option>
				</mat-autocomplete>
				<mat-error>
					<app-error-message [control]="'speciality'"></app-error-message>
				</mat-error>
			</mat-form-field>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<button mat-button appEheAnalytics [data]="analyticsData" class="button" (click)="shareData()">
				<span [translate]="'referral.request-referral.stepper.next-button'">Next</span>
			</button>
		</div>
	</div>
</form>
